module.exports = __webpack_public_path__ + "img/practice-2.77b98e68.jpg";